import TeamMemberCard from "./TeamMemberCard";
import Title from "./Title";

const team = [
  {
    name: "Camryn Terlouw",
    email: "1028434@hr.nl",
    imageUrl: "./camryn.png",
    linkedInUrl: "https://www.linkedin.com/in/camryn-t-907788226/",
  },
  {
    name: "Isis Ton",
    email: "1036029@hr.nl",
    imageUrl:
      "https://media.licdn.com/dms/image/C5603AQFBDMyV0q1gTw/profile-displayphoto-shrink_200_200/0/1639679780688?e=1714608000&v=beta&t=hbRWBB0hGZabpsDA2jFTBQeC3FVGCcVYELnGdf5_Xg4",
    linkedInUrl: "https://www.linkedin.com/in/isis-ton-aa9448227/",
  },
  {
    name: "Luke de Groot",
    email: "1028402@hr.nl",
    imageUrl: "./luke.jpg",
    linkedInUrl: "https://www.linkedin.com/in/luke-de-groot/",
  },
  {
    name: "Marijn Hokke",
    email: "1009049@hr.nl",
    imageUrl: "./marijn.png",
    linkedInUrl: "https://www.linkedin.com/in/marijn-hokke-a13633214/",
  },
];

export default function TeamSection() {
  return (
    <section className="py-10 sm:py-16">
      <Title
        title={"Ons team"}
        subtitle={"De creatieve technologen achter dit project"}
        linkableID={"over-ons"}
      />
      <div className="grid mx-auto lg:grid-cols-4 max-w-6xl md:grid-cols-3 grid-cols-2 gap-y-8">
        {team.map((member) => (
          <TeamMemberCard key={member.name} {...member} />
        ))}
      </div>
    </section>
  );
}
